import { Button, Group, Loader, Modal, Stack, Text } from '@mantine/core';
import { MarkdownView } from 'src/common/components/markdown-editor/MarkdownView';
import { formatSkillName } from 'src/common/utils/skillNames';
import AddToFirmButton from './AddToFirmButton';
import useSkillLibraryEntry from './hooks/useSkillLibraryEntry';
import type { SkillLibraryEntryListItem } from './types';

type SkillPreviewModalProps = {
  entry: SkillLibraryEntryListItem | null;
  firmName: string | null;
  onClose: () => void;
};

export default function SkillPreviewModal({ entry, firmName, onClose }: SkillPreviewModalProps) {
  const { data: skill, isLoading, isError } = useSkillLibraryEntry(entry?.id ?? null);

  return (
    <Modal
      opened={entry !== null}
      onClose={onClose}
      title={skill ? formatSkillName(skill.name) : 'Skill'}
      size="xl"
      centered
    >
      {isLoading && <Loader size="sm" />}
      {isError && (
        <Text c="red" role="alert">
          Couldn&apos;t load this skill. Please try again.
        </Text>
      )}
      {skill && entry && (
        <Stack gap="md">
          <Text size="sm" c="dimmed">
            {skill.description}
          </Text>
          <MarkdownView value={skill.markdown} />
          <Group justify="flex-end">
            <Button variant="default" onClick={onClose}>
              Close
            </Button>
            <AddToFirmButton entry={entry} firmName={firmName} />
          </Group>
        </Stack>
      )}
    </Modal>
  );
}
